import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'app-components';
import { useNavigate } from 'react-router-dom';

import { ENROLLMENT_ACTIONS, FROM_TAB } from './modalTypes';
import { getPlanSummaryData } from '@actions/individualPortal/planSummary/planSummaryActionCreators';
import useAppDispatch from '@hooks/useAppDispatch';
import { ModalContextType } from '@contexts/modalContext';
import { configs } from '@constants/configs/configs';
import { useStateCode } from '@hooks/useStateCode';
import { ConditionalRendering } from '@components/common/conditional-rendering';
import CapitalizedButton from '../components/common/CapitalizedButton';
import usePlanSummary from '@containers/individualPortal/planSummary/hooks/usePlanSummary';
import useAppSelector from '@hooks/useAppSelector';

interface IModalProps extends ModalContextType {
    enrollmentAction: ENROLLMENT_ACTIONS;
    fromTab?: string;
}
export default function SubmitDisenrollModal({ enrollmentAction, fromTab, closeModal, closeAllModals }: IModalProps) {

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { exchangeName } = useAppSelector(state => state.common.environment);
    const { isVoluntaryDisenrollmentVisible, isQuestionsTextVisible } = useStateCode();
    const { fetchPlanSummaryData } = usePlanSummary();

    function onClose(e) {
        e?.preventDefault();
        if (fromTab === FROM_TAB.PLANSUMMARY) {
            fetchPlanSummaryData();
            closeAllModals();
        } else {
            closeModal('submitDisenrollModal');
        }
    }

    function onContinue() {
        closeAllModals();
        navigate(configs.routes.INDPORTAL);
    }

    return (
        <Modal id="submitDisenrollModal">
            <Modal.Header
                id="submitDisenrollModalHeader"
                titleId={`indportal.submitDisenroll.header.${enrollmentAction}`}
                onHide={onClose}
            />
            <Modal.Body id="submitDisenrollModalBody">
                <ConditionalRendering isTrue={isVoluntaryDisenrollmentVisible}>
                    <FormattedMessage id={`indportal.submitDisenroll.recievedDisenrollRequest.${enrollmentAction}`} />
                </ConditionalRendering>
                <ConditionalRendering isTrue={!isVoluntaryDisenrollmentVisible}>
                    <FormattedMessage id="indportal.submitDisenroll.recievedDisenrollRequest.cancel" />
                </ConditionalRendering>
                <ConditionalRendering isTrue={isQuestionsTextVisible}>
                    <p>
                        <FormattedMessage id="indportal.plansummary.ifyouhaveanyquestions" values={{exchangeName}} />
                    </p>
                </ConditionalRendering>
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton
                    id="submitDisenrollModalGoToDashboardButton"
                    onClickHandler={onContinue}
                    variant="primary"
                    labelId="button.go_to_dashboard"
                />
            </Modal.Controls>
        </Modal>
    );
}
